<template>
  <div class="maintain">
    <my-head title="维护管理明细" :isRightClick = "true"/>
    <mu-paper :z-depth="1" class="loadmore-wrap" ref="wrapper" :style="{ height: wrapperHeight + 'px' }">
      <mu-container ref="container" class="loadmore-content">
        <mu-load-more :refreshing="refreshing" @refresh="refresh">
          <mu-container>
            <mu-paper :z-depth="1">
              <mu-data-table stripe :loading="tableLoading" :columns="columns" :sort.sync="sort" @sort-change="handleSortChange" :data="list" @row-click="rowTap">
                <template slot-scope="scope">
                  <td>{{scope.row.vin}}</td>
                  <td>{{scope.row.location}}</td>
                  <td>{{scope.row.time}}</td>
                </template>
              </mu-data-table>
            </mu-paper>
          </mu-container>
        </mu-load-more>
      </mu-container>
    </mu-paper>
  </div>
</template>

<script>
import myHead from '@/components/header'
import api from "@/common/api"
export default {
  name: 'maintain',
  components: {
    myHead
  },
  data () {
    return {
      refreshing: false,
      wrapperHeight: 0,
      tableLoading: true,
      sort: {
        name: '',
        order: 'asc'
      },
      columns: [
          { title: 'VIN',  name: 'vin'},
          { title: '库位', name: 'location', align: '', width: 100},
          { title: '维护时间', name: 'time',  align: '', width: 100}
      ],
      list: [],
      pageCode: null
    }
  },
  methods: {
    rowTap (index,row,event) {
      row.time === '' ? this.$router.push({name:'maintainlistkids',params:{row:row,pageCode:this.pageCode}}) : 
      this.Toast.fail({
        mask: true,
        message: "该单已维护"
      });
    },
    handleSortChange ({name, order}) {
      this.list = this.list.sort((a, b) => order === 'asc' ? a[name] - b[name] : b[name] - a[name]);
    },
    refresh () {
      // 下拉刷新
      this.refreshing = true;
      this.$refs.container.scrollTop = 0;
    },
    oneResdata (data,code) {
      this.common.reqData(api.app('maintainList'), Object.assign({},data,{
        content: {
          code: code
        }
      }), res=>{
        let datas = res.data;
        this.tableLoading = false;
        console.log("维护管理详细",datas);
        if(datas.status == 100){
            for(let item of datas.content.details){
              this.list.push({
                vin: item.vin,
                location: item.location,
                time:item.passTime,
                car: item.model,
                color: item.color,
                type: item.type
              });
            }
        }else{
          this.Toast.fail({
              duration: 3000,
              mask: true,
              message: datas.msg
          });
        }
      },err =>{
          console.log(err)
          this.Toast.clear();
      });
    }
  },
  mounted () {
    this.wrapperHeight = document.documentElement.clientHeight - 45
    if(this.$route.params.code){
      // 传过来的code有值的情况
      this.pageCode = this.$route.params.code;
      localStorage.setItem('maintainpagecode', this.$route.params.code);
      this.oneResdata(this.$store.state.user, this.pageCode);
    }else{
      this.pageCode = localStorage.getItem('maintainpagecode');
      this.oneResdata(this.$store.state.user, localStorage.getItem('maintainpagecode'));
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.loadmore-wrap {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.loadmore-wrap .mu-appbar {
    width: 100%;
}
.loadmore-content {
  flex: 1;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
.mu-paper.mu-paper-round.mu-elevation-1{
  -webkit-box-shadow: none;
  box-shadow: none;
}
.loadmore-content.container,.container{
    padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/maintain/maintainlist.vue